module.exports = __webpack_public_path__ + "img/new-chats-menu.9f04b805.svg";